import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { IBaseDepartment } from '../department.service';
import { objectValidator, ObjectValidators, ValidatorMap } from './objectValidator';

@Injectable({ providedIn: 'root' })
export class MesDepartmentValidationService {
	constructor(private translator: TranslateService) {}

	validators(ValidateId: boolean = true): ValidatorMap<IBaseDepartment> {
		const validator: ValidatorMap<IBaseDepartment> = {
			id: [ObjectValidators.required],
			alias: [
				ObjectValidators.required,
				ObjectValidators.maxLength(255),
				ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.department.dialog.alias.error.pattern'),
				ObjectValidators.pattern(ValidatorPatterns.NoStartOrEndWhitespacePattern, 'mes.administration.department.dialog.alias.error.pattern'),
			],
			name: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Description, 'mes.administration.department.dialog.name.errors.pattern')],
			isActive: [ObjectValidators.required],
			shiftApprovers: [ObjectValidators.required, ObjectValidators.minLength(1)],
		};

		if (!ValidateId) {
			delete validator.id;
		}

		return validator;
	}

	validateUser(user: IBaseDepartment, ValidateId: boolean = true): Record<string, ValidationErrors> {
		return objectValidator.validateObject(user, this.validators(ValidateId), this.translator);
	}
}
